import { FC, ReactNode, useEffect, useRef } from "react";
import CN from "classnames";
import { NavItem } from "../NavItem";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
// const { menuIconToggle } = useAppSelector((state) => state.SidebarState)
import { motion } from "framer-motion";
import { useAppContext } from "../../context/AppContext";
import {
  closeSidebar,
  toggleSidebar,
} from "../../store/reducers/side/sidebarMenu.Slice";
import Logo from "../../assets/images/logo.svg";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { PiListBulletsFill, PiUserGearFill, PiTagFill } from "react-icons/pi";
import { SlBadge } from "react-icons/sl";
import { BsCartCheckFill } from "react-icons/bs";
import { BsMegaphone, BsGiftFill, BsPeople, BsJournal } from "react-icons/bs";

export interface SidebarProps {
  [x: string]: any;
  open?: boolean | ReactNode;
  navbar?: boolean | ReactNode;
}

export const Sidebar: FC<SidebarProps> = ({
  className,
  open,
  navbar,
  ...restProps
}: SidebarProps) => {
  const SidebarClasses = CN(`sidebar`, className);

  // const { profileData, isLoading: ProfileLoading } = useSelector(
  //   (state: any) => state.profile
  // );
  // const { clientToken, isLoading } = useSelector(
  //   (state: any) => state.rootReducer.auth
  // );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeTab, setActiveTab } = useAppContext();
  const sidebarRef = useRef<any>(null);

  const { isOpen } = useSelector((state: any) => state.SidebarState);

  const handleTabClick = (tab: any) => {
    setActiveTab(tab);
  };

  //use ref handle in filter popup
  useEffect(() => {
    function assertIsNode(e: EventTarget | null): asserts e is Node {
      if (!e || !("nodeType" in e)) {
        throw new Error(`Node expected`);
      }
    }
    const checkIfClickedOutside = ({ target }: MouseEvent) => {
      assertIsNode(target);
      const id = (target as HTMLElement).getAttribute("id");

      if (!sidebarRef.current?.contains(target)) {
        if (id === "navmenu") {
          dispatch(closeSidebar());
        }
      } else {
        if (id === "navmenu") {
          dispatch(toggleSidebar());
        }
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isOpen]);

  // if (!profileData && ProfileLoading.userProfileData) {
  //   return <></>;
  // }
  return (
    <>
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.075 }}
        className={SidebarClasses}
        {...restProps}
      >
        <div
          ref={sidebarRef}
          className={`fixed h-full px-4  ${
            isOpen ? "md:w-264" : "max-sm:w-260 max-md:w-260"
          }  duration-300`}
        >
          <div className="flex flex-col h-full overflow-y-auto">
            {/* <i className={`ri-close-fill text-2xl absolute ml-52 py-1 px-2 text-light md:hidden ${isOpen ? 'hidden' : 'max-sm:block'}`} onClick={handleClickNow}></i> */}
            <div
              onClick={() => navigate("/")}
              className={`flex cursor-pointer items-center mb-10 justify-center  ${
                isOpen
                  ? "flex flex-row h-auto w-full mt-0"
                  : "mt-10 max-sm:mt-0"
              } max-sm:justify-start`}
            >
              <div
                className={`${
                  isOpen &&
                  "cursor-pointer hidden transition-all max-md:flex justify-center items-center"
                } mt-0`}
              >
                <img
                  className="w-12 max-sm:hidden max-md:hidden"
                  src={Logo}
                  alt="Damsel"
                />
              </div>
              <div
                className={`${
                  !isOpen &&
                  "hidden max-md:block transition-all max-sm:flex max-sm:w-[70%] max-sm:ml-5 max-sm:mb-3"
                } w-full flex justify-center items-center max-sm:mt-10 max-md:mt-0 ml-6 mr-12 mt-10`}
              >
                <img className="w-full" src={Logo} alt="Damsel" />
              </div>
            </div>

            <div className={`flex flex-col w-full ${!isOpen && ""}`}>
             
              <NavItem
                active={activeTab === "Products"}
                onClick={() => handleTabClick("Products")}
                linkPath="/products"
                userIcon={<BsFillBoxSeamFill size={24} />}
              >
                Products
              </NavItem>

              <NavItem
                active={activeTab === "Categories"}
                onClick={() => handleTabClick("Categories")}
                linkPath="/categories"
                userIcon={<PiListBulletsFill size={24} />}
              >
                Categories
              </NavItem>

              <NavItem
                active={activeTab === "Tags"}
                onClick={() => handleTabClick("Tags")}
                linkPath="/tags"
                userIcon={<PiTagFill size={24} />}
              >
                Tags
              </NavItem>

              <NavItem
                active={activeTab === "Admins"}
                onClick={() => handleTabClick("Admins")}
                linkPath="/admins"
                userIcon={<PiUserGearFill size={24} />}
              >
                Admins
              </NavItem>

              <NavItem
                active={activeTab === "Brands"}
                onClick={() => handleTabClick("Brands")}
                linkPath="/brands"
                userIcon={<SlBadge size={24} />}
              >
                Brands
              </NavItem>
              <NavItem
                active={activeTab === "users"}
                onClick={() => handleTabClick("users")}
                linkPath="/users"
                userIcon={<BsPeople size={24} />}
              >
                Users
              </NavItem>
              <NavItem
                active={activeTab === "Orders"}
                onClick={() => handleTabClick("Orders")}
                linkPath="/orders"
                userIcon={<BsCartCheckFill size={24} />}
              >
                Orders
              </NavItem>

              <NavItem
                active={activeTab === "Offers"}
                onClick={() => handleTabClick("Offers")}
                linkPath="/offers"
                userIcon={<BsGiftFill size={24} />}
              >
                Offers
              </NavItem>

              <NavItem
                active={activeTab === "Banners"}
                onClick={() => handleTabClick("Banners")}
                linkPath="/banners"
                userIcon={<BsMegaphone size={24} />}
              >
                Banners
              </NavItem>
               <NavItem
                active={activeTab === "Articles"}
                onClick={() => handleTabClick("Articles")}
                linkPath="/articles"
                userIcon={<BsJournal size={24} />}
              >
                Articles
              </NavItem>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;
